module.exports = __webpack_public_path__ + "media/images/lb/791-c0d6610352cc2b48384b93ced3b55356.svg";